// extracted by mini-css-extract-plugin
export default {"container":"styles_container__7DrA-","post":"styles_post__0qWU7","button":"styles_button__wSi20"};